import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import './index.css';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import { store } from './redux/store';
import {QueryClient, QueryClientProvider} from "@tanstack/react-query"
import ScrolltoTop from './components/feature/ScrolltoTop';

const root = ReactDOM.createRoot(document.getElementById('root'));
const queryclient = new QueryClient()
root.render(
  <React.StrictMode>
    <BrowserRouter>
    <Provider store={store}>
      <QueryClientProvider client={queryclient}>
        <ScrolltoTop/>
    <App />
      </QueryClientProvider>
    </Provider>
    </BrowserRouter>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
